export type ValidationResult = {
    isValid: boolean;
    error?: string;
};

export type DefermentValidationErrors = {
    amount?: string;
    date?: string;
};

export const validateDefermentAmount = (amount: number | null, cashDown: number): ValidationResult => {
    if (amount === null || isNaN(amount)) {
        return { isValid: false, error: 'Deferment amount must be a valid number' };
    }

    if (amount < 0) {
        return { isValid: false, error: 'Deferment amount cannot be less than 0' };
    }

    if (amount > cashDown) {
        return { isValid: false, error: `Amount cannot exceed Cash Down ($${cashDown.toLocaleString()})` };
    }

    return { isValid: true };
};

export const validateDefermentDate = (date: string | null): ValidationResult => {
    if (!date || date.trim() === '') {
        return { isValid: false, error: 'Deferment date is required' };
    }

    const selectedDate = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
        return { isValid: false, error: 'Deferment date cannot be in the past' };
    }

    return { isValid: true };
};

export const hasValidationErrors = (errors: DefermentValidationErrors): boolean => {
    return Object.values(errors).some((error) => !!error);
};
